<template>
    <div class="counter-style-two section-padding">
        <div class="container mb-50">
            <h2 class="titre-section">
                <span class="span-background">
                    EMCI et son équipe
                </span>
            </h2>
        </div>
        <div class="bloctitleText text-center mb-3 ml-5">
            Nous sommes des responsables RH, psychologues, juristes, formateurs, tous animés par la même passion :
            l’Humain.​
            Notre équipe s’appuie sur des expertises techniques variées et peut intervenir sur toute la France.​
        </div>
        <div class="d-flex justify-content-center mb-50">
            <a class="btn-transparent" href="/equipe">Découvrir <i class="fa-solid fa-arrow-right"></i> </a>
        </div>
        <div>
            <swiper ref="mySwiper" :slides-per-view="swiperPerView"
                :autoplay="{ delay: 3000, disableOnInteraction: true }">
                <swiper-slide v-for="i in groupImage" :key="i">
                    <div class="item">
                        <img :src="`/images/teams/group/${i}.jpeg`" alt="group1.jpeg" />
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Navigation, Autoplay } from "swiper";

const groupImage = ref([
    'group1',
    'group2',
    'group3',
    'group4',
    'group5'
])

const swiperPerView = ref(3);

SwiperCore.use([Navigation, Autoplay]);

const updateSwiperPerView = () => {
    if (typeof window !== "undefined") {
        if (window.innerWidth > 300 && window.innerWidth <= 750) {
            swiperPerView.value = 1;
        } else {
            swiperPerView.value = 3;
        }
    }
};

onMounted(async () => {
    if (window.innerWidth > 300 && window.innerWidth < 750) {
        swiperPerView.value = 1;
    } else {
        swiperPerView.value = 3;
    }
    window.addEventListener("resize", updateSwiperPerView);
});
onBeforeUnmount(() => {
    window.removeEventListener("resize", updateSwiperPerView);
});
</script>


<style scoped>
.titre-section {
    color: var(--accent, #25233E);
    text-align: center;
    font-family: Nunito;
    font-size: 3.125rem;
    /*50 px */
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    letter-spacing: -0.825px;
    text-transform: uppercase;
}

.section-padding {
    padding: 5rem 0;
}

img {
    height: 424px;
    object-fit: cover;
    border-radius: 10px;
}

.item {
    margin: 0 20px;
}

.bloctitleText {
    padding: 0 20rem;
    font-size: 20px;
}

.btn-transparent:hover {
    color: #fff;
    background: linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%);
}

/* Styles pour les écrans de petite taille (S) */
@media only screen and (max-width: 599px) {
    .bloctitleText {
        padding: 0 1rem;
    }

}


/* Styles pour les écrans de taille moyenne (M) */
@media only screen and (min-width: 600px) and (max-width: 768px) {
    .bloctitleText {
        padding: 0 5rem;
    }
}

@media only screen and (min-width: 769px) and (max-width: 991px) {}

@media only screen and (min-width: 1000px) and (max-width: 1024px) {}

@media only screen and (min-width: 1025px) and (max-width: 1087px) {}

@media only screen and (min-width: 1088px) and (max-width: 1872px) {}

@media only screen and (min-width: 1450px) and (max-width: 1800px) {}
</style>